import type {Theme, Components} from "../..";

type MenuItemOverrides = Components<Theme>["MuiMenuItem"];

const overrides: MenuItemOverrides = {
    defaultProps: {},
    styleOverrides: {
        root: ({theme}) => ({
            ...theme.typography.title4,
            fontWeight: theme.typography.fontWeight.medium,

            "&.Mui-focusVisible": {
                borderRadius: theme.borderRadius.default,
            },
            // Aligns the focus ring created in ButtonBase to the MenuItem
            "&::before": {
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
            },
        }),
    },
};

export default overrides;
